export const ALREADY_LINKED = 'already linked';
export const NO_RFI = 'no RFI';
